import { render, staticRenderFns } from "./Chatbox.vue?vue&type=template&id=0ebd05d2&scoped=true"
import script from "./Chatbox.vue?vue&type=script&lang=js"
export * from "./Chatbox.vue?vue&type=script&lang=js"
import style0 from "./Chatbox.vue?vue&type=style&index=0&id=0ebd05d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd05d2",
  null
  
)

export default component.exports